class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-drawer');
    this.notificationSuccess = this.notification.querySelector('.cart-drawer__success');

    this.button = document.getElementById('cart-icon-bubble');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.init();
  }

  init() {
    this.querySelectorAll('button[type="button"].cart-drawer__close').forEach((closeButton) =>
    closeButton.addEventListener('click', this.close.bind(this))
    );

  }


  open() {
    this.notification.classList.add('animate', 'active');
    this.classList.add('active');
    if(this.button){
      this.button.classList.add('animate', 'active');
    }
    document.body.classList.add('overflow-hidden');





    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.classList.remove('active');
    this.button.classList.remove('active');
    if (this.notificationSuccess) this.notificationSuccess.classList.add('hidden');




    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      if (this.notificationSuccess) this.notificationSuccess.classList.remove('hidden');
      if (this.header) this.header.reveal();
    this.open();
    this.init();
  }


  getSectionsToRender() {
      return [
        {
          id: 'cart-notification-products'
        },
        {
          id: 'cart-notification-links'
        },
        {
          id: 'cart-notification-warning'
        },
        {
          id: 'cart-notification-extra'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && target !== this.button  && !target.closest('cart-drawer')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartLink extends HTMLElement {
  constructor() {
    super();

    this.cartNotification = document.querySelector('cart-drawer');
    if (this.cartNotification) {
       
      this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.cartNotification.header) this.cartNotification.header.reveal();
        this.cartNotification.open();
      });
    }
  }

}

customElements.define('cart-link', CartLink);

if (!customElements.get('cart-drawer-items')) {


  class CartNotificationItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('cart-drawer-shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target);
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-products',
          section: 'cart-notification-products',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-links',
          section: 'cart-notification-links',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-warning',
          section: 'cart-notification-warning',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-extra',
          section: 'cart-notification-extra',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    addProduct(id, quantity) {
      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          const cartItems = document.getElementById('main-cart-items');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        
          }));
          cartItems.scrollIntoView();


          this.disableLoading();
        }).catch((e) => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }



    updateQuantity(line, quantity, name, input) {
      this.max = input.max;      
      if (this.max) {
        if (quantity > input.max) {
          document.getElementById(`Line-item-error-${line}`)
            .querySelector('.notification-cart-item__error-text')
            .innerHTML = window.cartStrings.quantityError.replace(
              '[quantity]',
              input.max
            );
          quantity = input.max;
        }
      }
      
      this.enableLoading(line);


      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });


      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
        }).catch((e) => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }

    updateLiveRegions(line, itemCount) {
      // console.log(line);
      // if (this.currentItemCount === itemCount) {
      //   document.getElementById(`Line-item-error-${line}`)
      //     .querySelector('.notification-cart-item__error-text')
      //     .innerHTML = window.cartStrings.quantityError.replace(
      //       '[quantity]',
      //       document.getElementById(`Quantity-${line}`).value
      //     );
      // }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-drawer-cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      line = line + 1;
      document.getElementById('cart-drawer').classList.add('cart__items--disabled');
      this.querySelectorAll(`#cart-drawer-product-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.getElementById('cart-drawer').classList.remove('cart__items--disabled');
    }
  }

  customElements.define('cart-drawer-items', CartNotificationItems);
  
}

class NotificationCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), event.target);
    });
  }
}

customElements.define('notification-cart-remove-button', NotificationCartRemoveButton);
